import { combineReducers } from 'redux';
import _keys from 'lodash/keys';
import _pick from 'lodash/pick';
import _without from 'lodash/without';
import _mapValues from 'lodash/mapValues';
import _union from 'lodash/union';
import _pickBy from 'lodash/pickBy';

import create from './modules/create/reducer';
import edit from './modules/edit/module/reducer';

import {
  REQUEST_COURSES,
  RECEIVE_COURSES,
  FILTER_COURSES,
  SELECT_COURSES,
  SELECT_ALL_COURSES,
  DESELECT_ALL_COURSES,
  GET_FIELDS_COURSES,
  INITIATE_MEMBER_BODY_COURSES,
} from './actions';

const initialState = {
  pending: false,
  chunks: {},
  selected: [],
  items: [],
  filteredChunks: {},
  filter: '',
  error: null,
  filteredChunksAll: {},
  memberbody: '',
};

const filterChunks = (chunks, filterHolder = '', keys) => {
  let filteredChunks = chunks;
  const filter = filterHolder.replace(/[^a-zA-Z0-9 ]/g, '');

  if (filter !== '') {
    filteredChunks = _pickBy(chunks, chunk => {
      const rgx = new RegExp(`(${filter})`, 'gi');
      return !!keys.find(key => rgx.test(chunk[key]));
    });
  }
  const items = Object.keys(filteredChunks);

  return { filteredChunks, items };
};

const list = (state = initialState, action) => {
  switch (action.type) {
    case REQUEST_COURSES:
      return {
        ...state,
        pending: true,
        error: null,
      };

    case RECEIVE_COURSES:
      return {
        ...state,
        chunks: action.value,
        selected: [],
        filteredChunks: action.value,
        items: _keys(action.value),
        pending: false,
        error: null,
      };

    case FILTER_COURSES:
      return {
        ...state,
        ...filterChunks(state.chunks, action.payload, action.keys),
        filter: action.payload,
      };

    case INITIATE_MEMBER_BODY_COURSES:
      return {
        ...state,
        memberbody: action.key,
      };

    case SELECT_COURSES: {
      const prevState = state.filteredChunks[action.key].selected;
      return {
        ...state,
        filteredChunks: {
          ...state.filteredChunks,
          [action.key]: {
            ...state.filteredChunks[action.key],
            selected: !prevState,
          },
        },
        selected:
          prevState === true
            ? _without(state.selected, action.key)
            : state.selected.concat(action.key),
      };
    }

    case SELECT_ALL_COURSES: {
      const filteredChunks = _pick(state.chunks, state.items);
      const selectedChunks = _mapValues(filteredChunks, chunk => ({
        ...chunk,
        selected: !chunk.default,
      }));
      const selected = _union(
        state.selected,
        Object.keys(filteredChunks).filter(chunk => chunk !== 'default'),
      );

      return {
        ...state,
        filteredChunks: {
          ...state.chunks,
          ...selectedChunks,
        },
        selected,
        selectAll: true,
      };
    }

    case DESELECT_ALL_COURSES:
      return {
        ...state,
        filteredChunks: _mapValues(state.chunks, chunk => ({
          ...chunk,
          selected: false,
        })),
        selected: [],
        selectAll: false,
      };

    case GET_FIELDS_COURSES:
      return {
        ...state,
        fields: action.value,
      };

    default:
      return state;
  }
};

export default combineReducers({
  list,
  create,
  edit,
});
